
import {useState} from 'react';
import { useForm } from "react-hook-form";
import Button from "../Button";
import Input from "../inputs/Input";
import Heading from '../Heading';
import Container from '../Container';

const NewsLatter = () => {
    const formValues = {
        firstName:"",
        lastName:"",
        email:"",
        phone:"",
        jobTitle:"",
        companySize:"",
        problem:""
    };

    const [isLoading,setIsLoading]  = useState(false)
    const {register,handleSubmit,reset,formState:{errors}} = useForm({
        defaultValues:formValues
    })

    const submitHandler = (data) => {
        console.log(data)
        reset(formValues);
    }

    return (
        <section className="section-7 py-5 py-lg-0 d-flex align-items-center">
            <Container>
                <div className="row">
                    <div className="col-12 col-lg-6 mb-4 mb-lg-0">
                        <div className="pe-0 pe-xl-5 d-flex align-items-center h-100">
                            <Heading 
                                heading={'Subscribe to our Monthly Cyber Security Memo'}
                            />
                        </div>
                    </div>
                    <div className="col-12 col-lg-6">
                        <Input 
                            label={'Email'}
                            type={'email'}
                            id={'email'} 
                            name={'email'}   
                            placeholder='Enter Email.'
                            disabled={isLoading}
                            register={register}
                            errors={errors}
                            required                                               
                        />  
                        <div className="d-block d-lg-flex align-items-center mt-3">
                            <div className="ps-5 position-relative">
                                <Input 
                                    label={'Email'}
                                    type={'checkbox'}
                                    id={'accept'} 
                                    name={'accept'}   
                                    disabled={isLoading}
                                    register={register}
                                    errors={errors}
                                    required={false}
                                /> 
                                <p>By submitting this form, you acknowledge that the information you provide will be processed in accordance with our <a href="#" title="Privacy Policy">Privacy Policy</a></p>
                            </div>
                            <div className="mt-3 mt-lg-0 ps-0 ps-lg-4">
                                <Button 
                                    icon={''}
                                    title="Subscribe"
                                    onClick={handleSubmit(submitHandler)}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </Container>		
        </section> 
    );
};

export default NewsLatter;